import React, { useState } from 'react'
import './userlogin.scss'
import API_CONSTANTS from '../api-constants'


const CreateAccount = () => {

    const [linkSent, setLinkSent] = useState(false)
    const [reply, setReply] = useState()
    const [emailEmpty, setEmailEmpty] = useState()
    const [email, setEmail] = useState()
    const [showNoValidEmail, setShowNoValidEmail] = useState()
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const validateEmail = (e) => {
        if (e.target?.value && e.target.value.match(isValidEmail)) {
            setShowNoValidEmail(false);
            setEmail(e.target.value)
           
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
       
       // console.log(email, 'email')
        !email && setEmailEmpty(true)
        if (email && email.length && email.match(isValidEmail)) {
          //  console.log('email is here and it is fully validated')
            let url = `${API_CONSTANTS.fetchUrl}/finishaccount`
            
          //  console.log(url)
//
            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/SendCreateLink?Email=${email}&URL=${url}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
            })
                .then((res) => res.json())
                .then((result) => {
                    //console.log(result)
                   
                        setLinkSent(true)
                        setReply(result.Message)
                   
                })

        }
        else if (email.length && !email.match(isValidEmail)){
            setShowNoValidEmail(true);
        }
    };

    const emailChanged = (e) => {
       
        setEmail(e.target.value)
        setEmailEmpty(false)
        validateEmail(e)
    }
    return (
        <div className="login" >
            
            <p className='profile'>Opret profil</p>
            {linkSent === true ?

                <p className='emailtext'>{reply }</p>
                :
                <>
            <p className='emailtext'>Indtast din email</p>
            <p className='emailinfo'>Indtast din email for at modtage et link til at oprette din konto</p>

            <form className='loginflow' onSubmit={(e) => handleSubmit(e)} style={{ marginTop: '30px' }}>
                        <label for='email' className='email-label'>Email</label>
                        <input id='email' autoComplete='email' className='email-input' style={{ border: emailEmpty === true ? '3px solid red' : '' }} placeholder='Indtast email' onChange={(e) => emailChanged(e)} />
                {emailEmpty === true ? <p className='email-error'>Venligst indtast din email</p> : null}
                {showNoValidEmail === true ? <p className = 'email-error'>Email er ikke gyldig</p> : null}
          
                <button type="submit" className='send_btn'>Send oprettelseslink </button>
                    </form>
                </>
            }
        </div>)
}

export default CreateAccount